import { useEffect, useRef, useState } from "react";
import { ShadowMark } from "../site/ShadowMark";

const SHADOW_DOWNLOAD_URL = "https://github.com/Converse-AI-Inc/Shadow/releases/latest";
const DESKTOP_PROTOCOL = process.env.REACT_APP_DESKTOP_PROTOCOL || "shadow";

export default function DesktopAuthCallback() {
  const hasTriggered = useRef(false);
  const [stage, setStage] = useState("opening");
  const [token, setToken] = useState(null);

  useEffect(() => {
    if (hasTriggered.current) return;
    hasTriggered.current = true;

    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (!t) {
      window.location.replace("/");
      return;
    }
    setToken(t);
    window.location.href = `${DESKTOP_PROTOCOL}://auth?token=${encodeURIComponent(t)}`;

    const stillHere = setTimeout(() => setStage("still-here"), 2000);
    const installHint = setTimeout(() => setStage("install-hint"), 8000);
    return () => {
      clearTimeout(stillHere);
      clearTimeout(installHint);
    };
  }, []);

  const retryDeepLink = () => {
    if (!token) return;
    window.location.href = `${DESKTOP_PROTOCOL}://auth?token=${encodeURIComponent(token)}`;
  };

  return (
    <div
      style={{
        backgroundColor: "#F5F5F5",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#1a1a1a",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
        padding: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "28px",
          maxWidth: "480px",
        }}
      >
        <ShadowMark size={96} />
        <h1
          style={{
            fontFamily: "Inter",
            fontSize: "2.5rem",
            fontWeight: 400,
            letterSpacing: "-0.01em",
            color: "#1a1a1a",
            margin: 0,
          }}
        >
          Opening Shadow...
        </h1>
        <p style={{ fontSize: "1rem", color: "#555", lineHeight: 1.6, margin: 0 }}>
          Your browser should now prompt you to open the app. Nothing happened?{" "}
          <button
            type="button"
            onClick={retryDeepLink}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              color: "#1a1a1a",
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
              font: "inherit",
            }}
          >
            Click here
          </button>{" "}
          to open.
        </p>
      </div>
    </div>
  );
}
